import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { thunk } from "redux-thunk"; // Import named export `thunk`
import loginReducer from "./redux/reducers/login";
import userReducer from "./redux/reducers/user";
import patientReducer from "./redux/reducers/patient";
import companyReducer from "./redux/reducers/company";
import subscriptionReducer from "./redux/reducers/subscription";
import paymentReducer from "./redux/reducers/payments";
import statsReducer from "./redux/reducers/stats";
import specialistReducer from "./redux/reducers/specialist";
import settingsReducer from "./redux/reducers/settings";
import visitReducer from "./redux/reducers/visit";
import patientDocumentReducer from "./redux/reducers/patientDocument";

const initialState = {};

const persistConfig = {
  key: "login",
  storage,
  blacklist: ["tokenAccess", "response", "stats", "payment", "settings"],
  // Complète chaque état sauvegardé avec les valeurs par défaut manquantes (ex. patient.limit)
  stateReconciler: autoMergeLevel2,
};

const rootReducer = combineReducers({
  login: loginReducer,
  user: userReducer,
  patient: patientReducer,
  company: companyReducer,
  subscription: subscriptionReducer,
  payment: paymentReducer,
  stats: statsReducer,
  specialist: specialistReducer,
  settings: settingsReducer,
  visit: visitReducer,
  patientDocument: patientDocumentReducer,
});

const middleware = [thunk];

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  persistedReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

const persistor = persistStore(store);

export { store, persistor };
